module.exports = __webpack_public_path__ + "static/media/ServiceLandingImages.603200fc.svg";